module.exports = __webpack_public_path__ + "static/media/DSC_0703.3fd7fc2a.jpg";